import { Component, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NavService } from '../../../../../_services/_nav.service';

@Component({
  selector: 'app-perfil-crezcamos-modal-firmantes',
  templateUrl: './perfil-crezcamos-modal-firmantes.component.html',
  styleUrls: ['./perfil-crezcamos-modal-firmantes.component.scss'],
})
export class PerfilCrezcamosModalFirmantesComponent implements OnInit {
  solicitud: any;
  listFirmantes: any[] = [];
  columnasFirmantes: any[];

  private config = inject( DynamicDialogConfig );
  private navServicio = inject( NavService );
  private ref = inject( DynamicDialogRef );

  ngOnInit(): void {
    this.solicitud = this.config.data.solicitud;
    this.listFirmantes = this.solicitud.firmantesDTO;
    this.cargarTabla();
  }

  async cargarTabla() {
    this.columnasFirmantes = [
      { field: 'nombreCompleto', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_NOMBRE'), sort: false },
      { field: 'vinculacion', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_VINCULACION'), sort: false },
      { field: 'numeroDocumento', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_NUMERODOCUMENTO'), sort: false },
      { field: 'parentesco', header: this.navServicio.buscarMensaje('PERFILCREZCAMOS.LBL_PARENTESTO'), sort: false },
    ];
  }
  
  convertirAbreviatura(abreviatura: string): string {
    return abreviatura.split('').join('.').toUpperCase() + '.';
  }

  cerrarModal() {
    this.ref.close();
  }
 }
